module.exports = __webpack_public_path__ + "static/img/zijianbusiness.a5f234c2.jpg";